import clsx from "clsx"
import { ComponentPropsWithoutRef, FC, PropsWithChildren, memo } from "react"
import styles from "./SwitchInlineItem.module.scss"

interface ISwitchInlineItem extends ComponentPropsWithoutRef<"div"> {
  isNew?: boolean
}

export const SwitchInlineItem: FC<PropsWithChildren<ISwitchInlineItem>> = memo(
  ({ children, className, isNew, ...props }) => {
    return (
      <div
        className={clsx(
          "switch-list-item",
          isNew && "new",
          styles.Item,
          { [styles.new]: isNew },
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)

SwitchInlineItem.displayName = "SwitchInlineItem"
